module.exports = __webpack_public_path__ + "img/29.8d3c51b3.png";